import { AppLanguage, getPreferredLanguage } from '../language';

export interface LabelingSingleOrderI18nTemplate {
  shared: {
    back: string;
    previous: string;
    endOrder: string;
    next: string;
    retry: string;
    loading: string;
    duplicateSuffix: string;
    unitLabel: string;
    inLabel: string;
    lbLabel: string;
    ozLabel: string;
  };
  addRecipientAddress: {
    titleCreate: string;
    titleEdit: string;
    description: string;
    recipientTitle: string;
    recipientNameLabel: string;
    recipientNamePlaceholder: string;
    phoneLabel: string;
    phonePlaceholder: string;
    phonePopupPlaceholder: string;
    addressTitle: string;
    streetLabel: string;
    streetPlaceholder: string;
    roomLabel: string;
    roomPlaceholder: string;
    cityLabel: string;
    cityPlaceholder: string;
    stateLabel: string;
    statePlaceholder: string;
    statePopupPlaceholder: string;
    zipLabel: string;
    zipPlaceholder: string;
    next: string;
    saving: string;
    validation: {
      phoneMinDigits: string;
      phoneInvalidChars: string;
      cityLettersOnly: string;
      cityNoAbbrev: string;
      stateRequired: string;
      stateInvalid: string;
      zipInvalid: string;
      fixErrorsBeforeSave: string;
      selectValidState: string;
      saveError: string;
    };
  };
  productInfo: {
    guidance: {
      inquiryTitle: string;
      inquiryDescription: string;
      title: string;
      singleDescription: string;
    };
    addItemTitle: string;
    addPackageTitle: string;
    selectOneError: string;
    incompletePackageError: string;
    duplicatePackageFailed: string;
    deletePackageFailed: string;
    systemErrorFallback: string;
    fetchPackagesFailedMessage: string;
    featureLabels: {
      dangerousGoods: string;
      batteryIncluded: string;
      signatureService: string;
      insurancePrefix: string;
    };
  };
  addProduct: {
    guidanceTitle: string;
    guidanceDescription: string;
    packageNamePlaceholder: string;
    packageNamePopupPlaceholder: string;
    dimensionsHeading: string;
    dimensionsSubtitle: string;
    weightPlaceholder: string;
    lengthPlaceholder: string;
    widthPlaceholder: string;
    heightPlaceholder: string;
    dangerousHeading: string;
    dangerousSubtitle: string;
    dangerousOptions: {
      dangerousGoods: {
        title: string;
        details: string;
      };
      batteryIncluded: {
        title: string;
        details: string;
      };
    };
    signatureHeading: string;
    signatureSubtitle: string;
    signatureOptions: {
      normal: {
        title: string;
        details: string;
      };
      adult: {
        title: string;
        details: string;
      };
    };
    insuranceHeading: string;
    insuranceSubtitle: string;
    insuranceCardTitle: string;
    insuranceCardDetails: string;
    insuranceAmountPrefix: string;
    insuranceAmountPlaceholder: string;
    duplicatePackageError: string;
    savePackageFailed: string;
    savePackageError: string;
    saving: string;
  };
}

export const TEMPLATES: Record<AppLanguage, LabelingSingleOrderI18nTemplate> = {
  zh: {
    shared: {
      back: '返回',
      previous: '上一步',
      endOrder: '结束下单',
      next: '下一步',
      retry: '重试',
      loading: '加载中...',
      duplicateSuffix: '复制',
      unitLabel: '单位',
      inLabel: '英寸',
      lbLabel: '磅',
      ozLabel: '盎司',
    },
    addRecipientAddress: {
      titleCreate: '新建收货地址',
      titleEdit: '编辑收货地址',
      description: '填写收货地址信息以便完成订单',
      recipientTitle: '收货人',
      recipientNameLabel: '收货人姓名',
      recipientNamePlaceholder: '输入收货人姓名',
      phoneLabel: '手机号',
      phonePlaceholder: '输入手机号',
      phonePopupPlaceholder: '请输入至少10位数字的手机号，可以包含()-和空格',
      addressTitle: '地址',
      streetLabel: '街道和门牌号',
      streetPlaceholder: '输入街道和门牌号',
      roomLabel: '房间号 (选填)',
      roomPlaceholder: '输入房间号 (选填)',
      cityLabel: '城市',
      cityPlaceholder: '输入城市名称',
      stateLabel: '州',
      statePlaceholder: '选择州',
      statePopupPlaceholder: '请从列表中选择州',
      zipLabel: '邮编',
      zipPlaceholder: '输入邮编',
      next: '下一步',
      saving: '保存中...',
      validation: {
        phoneMinDigits: '手机号必须至少包含10位数字',
        phoneInvalidChars: '手机号只能包含数字、空格和()-符号',
        cityLettersOnly: '城市名称只能包含英文字母',
        cityNoAbbrev: '城市名称不能为缩写',
        stateRequired: '州不能为空',
        stateInvalid: '请选择有效的州',
        zipInvalid: '邮编必须是5位或9位数字',
        fixErrorsBeforeSave: '请修正输入错误后再保存',
        selectValidState: '请从列表中选择有效的州',
        saveError: '保存地址时出错',
      },
    },
    productInfo: {
      guidance: {
        inquiryTitle: '你想寄什么',
        inquiryDescription: '选填项，如果不提供将返回完整价格表。',
        title: '添加包裹',
        singleDescription: '请选择一个包裹',
      },
      addItemTitle: '添加商品',
      addPackageTitle: '添加包裹',
      selectOneError: '请选择一个包裹',
      incompletePackageError: '包裹规格不完整，无法复制',
      duplicatePackageFailed: '复制包裹失败',
      deletePackageFailed: '删除包裹失败',
      systemErrorFallback: '系统错误，请稍后再试',
      fetchPackagesFailedMessage: '获取包裹列表失败',
      featureLabels: {
        dangerousGoods: '危险品',
        batteryIncluded: '含电池',
        signatureService: '签名服务',
        insurancePrefix: '保险',
      },
    },
    addProduct: {
      guidanceTitle: '添加包裹',
      guidanceDescription: '填写包裹信息以便完成订单',
      packageNamePlaceholder: '包裹名称',
      packageNamePopupPlaceholder: '这款包裹是什么',
      dimensionsHeading: '包裹重量和尺寸',
      dimensionsSubtitle: '必填项。提供后可获得精确的快递面单价格。',
      weightPlaceholder: '商品包装后的重量',
      lengthPlaceholder: '包裹长度',
      widthPlaceholder: '包裹宽度',
      heightPlaceholder: '包裹高度',
      dangerousHeading: '该包裹是危险品或含电池吗？',
      dangerousSubtitle: '选填项。可接收危险品和含电池包裹的海外仓较少，且收费更高。',
      dangerousOptions: {
        dangerousGoods: {
          title: '危险品',
          details: '酒精、打火机、喷雾剂等易爆物品和化学物品。',
        },
        batteryIncluded: {
          title: '含电池商品',
          details: '通常指电池容量大于100瓦时的商品。',
        },
      },
      signatureHeading: '是否需要购买签名服务',
      signatureSubtitle: '选填项。',
      signatureOptions: {
        normal: {
          title: '普通签名',
          details: '适用于邮寄贵重商品。',
        },
        adult: {
          title: '成人签名',
          details: '适用于邮寄酒精等不允许青少年购买的商品。',
        },
      },
      insuranceHeading: '是否需要保险服务',
      insuranceSubtitle: '选填项。购买保险可在包裹损失或损坏时获得赔偿。',
      insuranceCardTitle: '购买保险',
      insuranceCardDetails: '为您的包裹增加额外保障',
      insuranceAmountPrefix: '保险金额',
      insuranceAmountPlaceholder: '输入保险金额',
      duplicatePackageError: '已存在完全相同规格的包裹，请修改后重试',
      savePackageFailed: '保存包裹失败',
      savePackageError: '保存包裹时出错',
      saving: '保存中...',
    },
  },
  en: {
    shared: {
      back: 'Back',
      previous: 'Previous',
      endOrder: 'End Order',
      next: 'Next',
      retry: 'Retry',
      loading: 'Loading...',
      duplicateSuffix: 'Copy',
      unitLabel: 'Unit',
      inLabel: 'in',
      lbLabel: 'lb',
      ozLabel: 'oz',
    },
    addRecipientAddress: {
      titleCreate: 'Create Recipient Address',
      titleEdit: 'Edit Recipient Address',
      description: 'Fill recipient address details to continue order creation.',
      recipientTitle: 'Recipient',
      recipientNameLabel: 'Recipient Name',
      recipientNamePlaceholder: 'Enter recipient name',
      phoneLabel: 'Phone Number',
      phonePlaceholder: 'Enter phone number',
      phonePopupPlaceholder:
        'Enter at least 10 digits. You can include spaces, (), and -.',
      addressTitle: 'Address',
      streetLabel: 'Street Address',
      streetPlaceholder: 'Enter street address',
      roomLabel: 'Apt / Unit (Optional)',
      roomPlaceholder: 'Enter apt / unit (optional)',
      cityLabel: 'City',
      cityPlaceholder: 'Enter city',
      stateLabel: 'State',
      statePlaceholder: 'Select state',
      statePopupPlaceholder: 'Please select a state from the list',
      zipLabel: 'ZIP Code',
      zipPlaceholder: 'Enter ZIP code',
      next: 'Next',
      saving: 'Saving...',
      validation: {
        phoneMinDigits: 'Phone number must contain at least 10 digits.',
        phoneInvalidChars: 'Phone number can only contain digits, spaces, (), and -.',
        cityLettersOnly: 'City can only contain letters.',
        cityNoAbbrev: 'City name cannot be abbreviated.',
        stateRequired: 'State is required.',
        stateInvalid: 'Please select a valid state.',
        zipInvalid: 'ZIP code must be 5 or 9 digits.',
        fixErrorsBeforeSave: 'Please fix input errors before saving.',
        selectValidState: 'Please select a valid state from the list.',
        saveError: 'An error occurred while saving the address.',
      },
    },
    productInfo: {
      guidance: {
        inquiryTitle: 'What are you shipping?',
        inquiryDescription: 'Optional. If omitted, we will return the full rate table.',
        title: 'Add Package',
        singleDescription: 'Please select one package.',
      },
      addItemTitle: 'Add Product',
      addPackageTitle: 'Add Package',
      selectOneError: 'Please select one package.',
      incompletePackageError: 'Package specs are incomplete and cannot be duplicated.',
      duplicatePackageFailed: 'Failed to duplicate package.',
      deletePackageFailed: 'Failed to delete package.',
      systemErrorFallback: 'System error, please try again later.',
      fetchPackagesFailedMessage: 'Failed to fetch package list',
      featureLabels: {
        dangerousGoods: 'Dangerous Goods',
        batteryIncluded: 'Battery Included',
        signatureService: 'Signature Service',
        insurancePrefix: 'Insurance',
      },
    },
    addProduct: {
      guidanceTitle: 'Add Package',
      guidanceDescription: 'Fill package details to continue order creation.',
      packageNamePlaceholder: 'Package Name',
      packageNamePopupPlaceholder: 'What is this package?',
      dimensionsHeading: 'Package Weight and Dimensions',
      dimensionsSubtitle: 'Required. Provide this to get accurate shipping label pricing.',
      weightPlaceholder: 'Weight After Packaging',
      lengthPlaceholder: 'Package Length',
      widthPlaceholder: 'Package Width',
      heightPlaceholder: 'Package Height',
      dangerousHeading: 'Is this package dangerous goods or battery-included?',
      dangerousSubtitle:
        'Optional. Fewer warehouses accept dangerous or battery-included packages, usually at higher cost.',
      dangerousOptions: {
        dangerousGoods: {
          title: 'Dangerous Goods',
          details: 'Flammable items and chemicals such as alcohol, lighters, and aerosols.',
        },
        batteryIncluded: {
          title: 'Battery Included',
          details: 'Typically items with battery capacity over 100Wh.',
        },
      },
      signatureHeading: 'Do you need signature service?',
      signatureSubtitle: 'Optional.',
      signatureOptions: {
        normal: {
          title: 'Standard Signature',
          details: 'Recommended for valuable goods.',
        },
        adult: {
          title: 'Adult Signature',
          details: 'Recommended for alcohol and other age-restricted items.',
        },
      },
      insuranceHeading: 'Do you need insurance?',
      insuranceSubtitle: 'Optional. Insurance can cover loss or damage.',
      insuranceCardTitle: 'Buy Insurance',
      insuranceCardDetails: 'Add extra protection for your package.',
      insuranceAmountPrefix: 'Insurance Amount',
      insuranceAmountPlaceholder: 'Enter insurance amount',
      duplicatePackageError: 'An identical package already exists. Please modify and retry.',
      savePackageFailed: 'Failed to save package.',
      savePackageError: 'An error occurred while saving the package.',
      saving: 'Saving...',
    },
  },
};

export const LABELING_SINGLE_ORDER_NAMESPACE = 'labelingSingleOrder';

export const LABELING_SINGLE_ORDER_RESOURCE_KEY = 'template';

export const LABELING_SINGLE_ORDER_I18N_RESOURCES: Record<
  AppLanguage,
  Record<typeof LABELING_SINGLE_ORDER_RESOURCE_KEY, LabelingSingleOrderI18nTemplate>
> = {
  zh: {
    [LABELING_SINGLE_ORDER_RESOURCE_KEY]: TEMPLATES.zh,
  },
  en: {
    [LABELING_SINGLE_ORDER_RESOURCE_KEY]: TEMPLATES.en,
  },
};

export const getLabelingSingleOrderTemplate = (
  language: AppLanguage = getPreferredLanguage(),
): LabelingSingleOrderI18nTemplate => TEMPLATES[language] || TEMPLATES.zh;
